<template>
    <div class="wrap">
        <el-form ref="formRef" :model="formData" :rules="rules" label-width="100px">
            <el-form-item label="消息范围" prop="type">
                <el-radio-group v-model="formData.type" @change="typeChange">
                    <el-radio :value="0" >集团校区</el-radio>
                    <el-radio :value="1" >职能部门</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="消息类型" prop="noticeTypeId">
                <el-radio-group v-model="formData.noticeTypeId">
                    <el-radio v-for="item in noticeTypeList" :key="item.id" :value="item.id">{{ item.noticeType
                        }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <template v-if="formData.type == 0">
              <el-form-item label="接收部门" prop="departmentType">
                  <el-radio-group v-model="formData.departmentType" @change="selectDepartment">
                      <el-radio value="大区" label="大区">
                          <div class="flex-wrap">
                              <span>大区</span>
                              <departmentCascader v-if="formData.departmentType === '大区'" v-model="formData.department"
                                  placeholder="请选择接收大区" ref="schoolCas" :checkAll="false" :level="1"
                                  @change="selectDepartment" returnType="String" />
                          </div>
                      </el-radio>
                      <el-radio value="区域">
                          <div class="flex-wrap">
                              <span>区域</span>
                              <departmentCascader v-if="formData.departmentType === '区域'" v-model="formData.department"
                                  placeholder="请选择接收区域" ref="schoolCas" :checkAll="false" :level="2"
                                  @change="selectDepartment" returnType="String" />
                          </div>
                      </el-radio>
                      <el-radio value="校区">
                          <div class="flex-wrap">
                              <span>校区</span>
                              <departmentCascader v-if="formData.departmentType === '校区'" v-model="formData.department"
                                  placeholder="请选择接收校区" ref="schoolCas" :checkAll="false" @change="selectDepartment"
                                  returnType="String" />
                          </div>
                      </el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="指定接收人">
                  <div class="flex-wrap">
                      <el-checkbox-group v-model="formData.role"
                          :disabled="!(formData.department && formData.department.length > 0)">
                          <el-checkbox v-for="(item, index) in receiverList" :key="index" :value="item.roleId"
                                @change="val=>changeBox(val,true, item)">
                              {{ item.name }}
                              <el-select v-if="item.roleType === '市场区域' && formData.role?.includes(item.roleId)"
                                  v-model="item.value" placeholder="请选择" :empty-values="[null, undefined]"
                                  filterable @change="changeBox(true, true, item)">
                                  <el-option v-for="item in channelList" :key="item.value" :label="item.label"
                                      :value="item.value" />
                              </el-select>
                          </el-checkbox>
                      </el-checkbox-group>
                      <staffSelector v-model="eRoleUserStrList"
                          :disabled="!(formData.department && formData.department.length > 0)" :multiple="true"
                          :collapse-tags="true" collapse-tags-tooltip :clearable="true" placeholder="添加接收人"
                          @change="addERole" style="width: 240px"></staffSelector>
                  </div>
              </el-form-item>
              <el-form-item label="已选接收人" v-if="Array.isArray(totalRoleUsers) && totalRoleUsers.length > 0">
                  <div class="flex-wrap">
                      <el-tag v-for="tag in totalRoleUsers" :key="tag.userId" closable @close="handleDeleteRole(tag)"
                          type="info">
                          {{ showName(tag) }}
                      </el-tag>
                  </div>
              </el-form-item>
              <el-form-item label="抄送人">
                  <div class="flex-wrap">
                      <el-checkbox-group :disabled="!Array.isArray(totalRoleUsers) || totalRoleUsers.length === 0"
                          v-model="formData.ccRole">
                          <el-checkbox v-for="(item, index) in ccReceiverList" :key="index" :value="item.roleId"
                               @change="val=>changeBox(val,false, item)">
                              {{ item.name }}
                              <el-select v-if="item.roleType === '市场区域' && formData.ccRole?.includes(item.roleId)"
                                  v-model="item.value" placeholder="请选择" :empty-values="[null, undefined]"
                                   filterable  @change="changeBox(true, false, item)">
                                  <el-option v-for="item in channelList" :key="item.value" :label="item.label"
                                      :value="item.value" />
                              </el-select>
                          </el-checkbox>
                      </el-checkbox-group>
                      <staffSelector v-model="eCCUserStrList"
                          :disabled="!Array.isArray(totalRoleUsers) || totalRoleUsers.length === 0" :multiple="true"
                          :collapse-tags="true" collapse-tags-tooltip :clearable="true" placeholder="添加抄送人"
                          @change="addECCRole" style="width: 240px"></staffSelector>
                  </div>
              </el-form-item>
              <el-form-item label="已选抄送人" v-if="Array.isArray(totalCCRoleUsers) && totalCCRoleUsers.length > 0">
                  <div class="flex-wrap">
                      <el-tag v-for="tag in totalCCRoleUsers" :key="tag.userId" closable type="info"
                          @close="handleDeleteCCRole(tag)">
                          {{ showName(tag) }}
                      </el-tag>
                  </div>
              </el-form-item>
            </template>
            <template v-if="formData.type == 1">
                <el-form-item label="指定接收人" class="form-star">
                  <el-cascader
                    style="width:600px;"
                    v-model="eRoleUserStrList"
                    :options="deptTreeList"
                    filterable
                    ref="acceptRef"
                    :props="{
                        multiple: true,
                        label:'deptName',
                        value:'deptId1',
                        children:'children',
                        emitPath:false,
                    }"
                    :show-all-levels="false"
                    @change="addEAccept"
                    collapse-tags
                    :max-collapse-tags="5"
                    collapse-tags-tooltip
                    clearable
                  />
                </el-form-item>
                <el-form-item label="已选接收人" v-if="Array.isArray(totalRoleUsers) && totalRoleUsers.length > 0">
                  <div class="flex-wrap">
                      <el-tag v-for="tag in totalRoleUsers" :key="tag.userId" closable @close="handleDeleteRole(tag)"
                          type="info">
                          {{ showName(tag) }}
                      </el-tag>
                  </div>
                </el-form-item>
                <el-form-item label="抄送人">
                    <el-cascader
                        style="width:600px;"
                        v-model="eCCUserStrList"
                        :options="deptTreeList"
                        filterable
                        ref="ccRef"
                        :props="{
                            multiple: true,
                            label:'deptName',
                            value:'deptId1',
                            children:'children',
                            emitPath:false,
                        }"
                        :show-all-levels="false"
                        @change="addCCUser"
                        collapse-tags
                        :max-collapse-tags="5"
                        collapse-tags-tooltip
                        clearable
                    />
                </el-form-item>
                <el-form-item label="已选抄送人" v-if="Array.isArray(totalCCRoleUsers) && totalCCRoleUsers.length > 0">
                    <div class="flex-wrap">
                        <el-tag v-for="tag in totalCCRoleUsers" :key="tag.userId" closable type="info"
                            @close="handleDeleteCCRole(tag)">
                            {{ showName(tag) }}
                        </el-tag>
                    </div>
                </el-form-item>
            </template>
            <el-form-item label="主题" prop="theme">
                <el-input v-model="formData.theme" placeholder="请输入主题" maxlength="20" clearable />
            </el-form-item>
            <el-form-item label="正文" prop="content">
                <rich-text-input class="rich-item" use-base64 v-model="formData.content" />
            </el-form-item>
            <div class="flex-row" >
                <el-checkbox style="width: 100px;" v-model="formData.filesUrlShow" :true-value="0"
                    :false-value="1">页面快照</el-checkbox>
                <el-image
                  style="width: 120px; height: 80px;"
                  :src="formData.filesUrl"
                  v-loading="!formData.filesUrl"
                  preview-teleported
                  :preview-src-list="[formData.filesUrl]"
                >
                    <template #placeholder>
                      <div class="image-viewer-placeholder image-slot">
                            加载中...
                      </div>
                    </template>
                </el-image>
            </div>
            <el-space style="margin: 10px 0 0 100px;" direction="vertical" alignment="normal">
              <el-text class="text">快照页面：{{ formData.menuId }}</el-text>
              <el-text class="text">快照链接：{{ formData.pageUrl }}</el-text>
            </el-space>
        </el-form>
    </div>
</template>

<script setup>
import { uploadFileApi } from "@/api/messageSystem";
import departmentCascader from './departmentCascader.vue';
import RichTextInput from '@/components/EnhanceForm/RichTextInput.vue';
import { operationNoticeTypeList, operationNoticeRoleListAll, operationNoticeSelectUser,deptTreeListApi } from '@/api/messageSystem';
import { getChannelConfigList } from '@/api/market/channelConfig';
import { ElMessage } from 'element-plus';
import html2canvas14 from 'html2canvas-v1.4'
const props = defineProps({
    dialog: {
        type: Boolean,
        default: false, //弹窗打开 true 新增  false 草稿箱编辑
    },
    originData: {
        type: Object,
        default: () => ({}),
    }
});

const showName = (item) => {
    return (item.name ?? item.userName ?? '') + (item.postName ?? "");
}
// 选择角色后的人员列表
const ccUsers = ref([])
// 添加额外抄送人id数组
const eCCUserStrList = ref([]);
// 添加额外抄送人列表
const eCCUserList = ref([]);
// 所有抄送人列表
const totalCCRoleUsers = ref([]);

// 选择角色的 人员列表
const roleUsers = ref([])
// 添加额外接收人id数组
const eRoleUserStrList = ref([]);
// 添加额外接收人列表
const eRoleUserList = ref([]);
// 所有接收人列表
const totalRoleUsers = ref([]);


//表单参数
const route = useRoute();
const formData = ref({
  type:0,
  filesUrlShow: 0,
  ccRole:[] ,
  role:[],
  filesUrl:'',
  pageUrl: window.location.origin + route.fullPath,
  menuId: route.meta.title,
});
const formRef = ref(null);
watch(
    () => props.originData,
    (val) => {
        if(val){
            formData.value = { ...formData.value, ...val };
            if (val?.role) {
                formData.value.role = val.role.split(',');
            }else{
                formData.value.role = []
            }
            if (val?.ccRole) {
                formData.value.ccRole = val.ccRole.split(',') || [];
            }else{
                formData.value.ccRole = []
            }
            if(val?.userInfo){
                roleUsers.value = [...val.userInfo];
                totalRoleUsers.value = [...val.userInfo]
                if(val.type == 1){
                    eRoleUserStrList.value = val.roleUser.split(',') || [];
                }
            }
            if(val?.ccUserInfo){
                ccUsers.value = [...val.ccUserInfo]
                totalCCRoleUsers.value = [...val.ccUserInfo]
                if(val.type == 1){
                    eCCUserStrList.value = val.ccUser.split(',') || [];
                }
            }
        }
    },
    { deep: true, immediate: true }
);

onMounted(() => {
    if (props.dialog) return;
    loadData();
});
onUnmounted(()=>{
    formData.value = { type:0,filesUrlShow: 0,filesUrl:'',pageUrl: '',menuId:''};
})
const handleScreenshot = async () => {
  if(!props.dialog) return
  try {
    const app = document.getElementById("app");
    const canvas = await html2canvas14(app, {
      useCORS: true,
      width:document.body.clientWidth,
      height: document.body.clientHeight,
    });
    // 转Blob
    const blob = await new Promise((resolve) =>
      canvas.toBlob((blob) => resolve(blob), "image/png")
    );
    const params = new FormData();
    params.append("file", blob, `${Date.now()}_screenshot.png`);
    const { data } = await uploadFileApi(params);
    formData.value = {...formData.value,filesUrl:data.url}
  } catch (error) {
    console.log(error);
    ElMessage.error("截屏失败");
  }
};
const loading = ref(false)
const noticeTypeList = ref([]);
const channelList = ref([]);
const receiverList = ref([]);
const ccReceiverList = ref([]);
const deptTreeList = ref([])
const deptUserList = ref([])
const loadData = async () => {
    loading.value = true;
    try {
      const { data } = await operationNoticeTypeList({ status: 0 });
      noticeTypeList.value = data.map((item) => ({
          id: item.id,
          noticeType: item.noticeType,
      }));
      const { rows } = await getChannelConfigList({ status: 1 });
      channelList.value = rows.map((item) => ({
          value: item.channelId,
          label: item.name,
      }));
      channelList.value.unshift({
          value: '全部',
          label: "全部",
      });
      const { data: roleList } = await operationNoticeRoleListAll();
      const {data:dList} = await deptTreeListApi()
      if(dList&&dList.length){
        deptTreeList.value = dList;
        deptUserList.value = dList[0].userInfoMap;
      }
      loading.value = false;
      const temRoleList = roleList.map((item) => {
          item.value = null;
          return item
      });
      receiverList.value = temRoleList
      ccReceiverList.value = temRoleList
      handleScreenshot()
    } catch (error) {
      loading.value = false
    }
};
// 接收人和抄送人
const changeBox = async (val, isSend, item) => {
    if (val && item.value == null && item.roleType === '市场区域') {
        return;
    }
    let value = item.value
    console.log(val, item);
    if (value === '全部' || val == false) {
        value = channelList.value.filter(it => it.label !== '全部').map(it => it.value).join(',');
    }
    let params = { departments: formData.value.department, roleIds: item.roleId, id: item.id, departmentsType: formData.value.departmentType }
    if (value) {
        params.markets = value;
    }
    const { data } = await operationNoticeSelectUser(params);
    console.log(data);
    if (isSend) {
        let temList = [];
        if (val) {
            const merged = [...data, ...roleUsers.value];
            const uniqueList = Array.from(new Map(merged.map(item => [item.userId, item])).values());
            temList = uniqueList;
        } else {
            item.value = null;
            let list = data.map(item => item.userId);
            temList = roleUsers.value.filter(item => !list.includes(item.userId));
        }
        const ids = totalCCRoleUsers.value.map(item => item.userId);
        temList = temList.filter(item => !ids.includes(item.userId));
        roleUsers.value = temList;
        totalRoleUsers.value = [...roleUsers.value, ...eRoleUserList.value];
    } else {

        let temList = [];
        if (val) {
            const merged = [...data, ...ccUsers.value];
            const uniqueList = Array.from(new Map(merged.map(item => [item.userId, item])).values());
            temList = uniqueList;
        } else {
            item.value = null;
            let list = data.map(item => item.userId);
            temList = ccUsers.value.filter(item => !list.includes(item.userId));
        }
        const ids = totalRoleUsers.value.map(item => item.userId);
        temList = temList.filter(item => !ids.includes(item.userId));
        ccUsers.value = temList;
        totalCCRoleUsers.value = [...ccUsers.value, ...eCCUserList.value];
    }
};

const selectDepartment = () => {
    //  清除 指定接收人和抄送人
    formData.value.department = null;
    roleUsers.value = [];
    eRoleUserStrList.value = [];
    eRoleUserList.value = [];
    totalRoleUsers.value = [];
    formData.value.role = [];
    ccUsers.value = [];
    eCCUserStrList.value = [];
    eCCUserList.value = [];
    totalCCRoleUsers.value = [];
    formData.value.ccRole = []; // 清除抄送人
    receiverList.value = receiverList.value.map(item => ({ ...item, value: null }));
    ccReceiverList.value = ccReceiverList.value.map(item => ({ ...item, value: null }));
};

const addECCRole = (val) => {
    if (eCCUserStrList.value.length == 0) {
        eCCUserList.value = [];
    } else {
        const merged = [...val, ...eCCUserList.value];
        const uniqueList = Array.from(new Map(merged.map(item => [item.userId, item])).values());
        const roleUserIds = ccUsers.value.map(u => u.userId);
        const totalUserIds = totalRoleUsers.value.map(u => u.userId);
        if (eCCUserStrList.value.some(id => roleUserIds.includes(id))) {
            ElMessage.warning('抄送人已存在');
        }
        if (eCCUserStrList.value.some(id => totalUserIds.includes(id))) {
            ElMessage.warning('该人员已是接收人,无法添加抄送');
        }
        eCCUserStrList.value = eCCUserStrList.value.filter(id => !roleUserIds.includes(id));
        eCCUserStrList.value = eCCUserStrList.value.filter(id => !totalUserIds.includes(id));
        const filteredList = uniqueList.filter(item => eCCUserStrList.value.includes(item.userId));
        eCCUserList.value = filteredList;
    }
    totalCCRoleUsers.value = [...eCCUserList.value, ...ccUsers.value];
}
const handleDeleteCCRole = (val) => {
    eCCUserStrList.value = eCCUserStrList.value.filter(id => id !== val.userId);
    totalCCRoleUsers.value = totalCCRoleUsers.value.filter(item => item.userId !== val.userId);
    eCCUserList.value = eCCUserList.value.filter(item => item.userId !== val.userId);
    ccUsers.value = ccUsers.value.filter(item => item.userId !== val.userId);
};

const addERole = (val) => {
    console.log(val);
    if (eRoleUserStrList.value.length == 0) {
        eRoleUserList.value = [];
    } else {
        const merged = [...val, ...eRoleUserList.value];
        const uniqueList = Array.from(new Map(merged.map(item => [item.userId, item])).values());
        const roleUserIds = roleUsers.value.map(u => u.userId);
        const totalUserIds = totalCCRoleUsers.value.map(u => u.userId);
        if (eRoleUserStrList.value.some(id => roleUserIds.includes(id))) {
            ElMessage.warning('接收人已存在');
        }
        if (eRoleUserStrList.value.some(id => totalUserIds.includes(id))) {
            ElMessage.warning('该人员已是抄送人,无法添加接收');
        }
        eRoleUserStrList.value = eRoleUserStrList.value.filter(id => !roleUserIds.includes(id));
        eRoleUserStrList.value = eRoleUserStrList.value.filter(id => !totalUserIds.includes(id));
        const filteredList = uniqueList.filter(item => eRoleUserStrList.value.includes(item.userId));
        eRoleUserList.value = filteredList;
    }
    totalRoleUsers.value = [...eRoleUserList.value, ...roleUsers.value];
};
const handleDeleteRole = (val) => {
    eRoleUserStrList.value = eRoleUserStrList.value.filter(id => id !== val.userId);
    totalRoleUsers.value = totalRoleUsers.value.filter(item => item.userId !== val.userId);
    eRoleUserList.value = eRoleUserList.value.filter(item => item.userId !== val.userId);
    roleUsers.value = roleUsers.value.filter(item => item.userId !== val.userId);
};

const acceptRef = ref(null)
const addEAccept = (val)=>{
  console.log(val)
  const list = acceptRef.value.getCheckedNodes(true)
  if(list.length){
      const excludeUserIds = totalCCRoleUsers.value.map(u => u.userId);
      const onlyList = list.filter(item=>{
          if(!excludeUserIds.includes(item.value)){
            return true
          }else{
              eRoleUserStrList.value = eRoleUserStrList.value.filter(id => id !== item.value);
              ElMessage.warning(`该人员 ${item.text} 已是抄送人,无法添加`);
          }
      });
      totalRoleUsers.value = onlyList.map(item=>{
          return{
              name:item.text,
              userId:item.value
          }
      })
  }else{
      totalRoleUsers.value = []
  }
}
const ccRef = ref(null)
const addCCUser = (val)=>{
  console.log(val)
  const list = ccRef.value.getCheckedNodes(true)
  if(list.length){
      const excludeUserIds = totalRoleUsers.value.map(u => u.userId);
      const onlyList = list.filter(item=>{
          if(!excludeUserIds.includes(item.value)){
            return true
          }else{
              eCCUserStrList.value = eCCUserStrList.value.filter(id => id !== item.value);
              ElMessage.warning(`该人员 ${item.text} 已是接收人,无法添加`);
          }
      });
      totalCCRoleUsers.value = onlyList.map(item=>{
          return{
              name:item.text,
              userId:item.value
          }
      })
  }else{
      totalCCRoleUsers.value = []
  }
}
// 后面再用 formData
//表单验证规则
const rules = reactive({
    type:[
        {
            required: true,
            message: '请选择消息范围',
            trigger: ['blur', 'change'],
        },
    ],
    noticeTypeId: [
        {
            required: true,
            message: '请选择消息类型',
            trigger: ['blur', 'change'],
        },
    ],
    departmentType: [
        {
            required: true,
            message: '接收部门',
            trigger: ['blur', 'change'],
        },
    ],
    theme: [
        {
            required: true,
            message: '请输入主题',
            trigger: ['blur', 'change'],
        },
    ],
    content: [
        {
            required: true,
            message: '请输入内容',
            trigger: ['blur', 'change'],
        },
    ],
});
// status 0 保存， 1 发送，2 禁用
function commit(status) {
    return new Promise((resolve, reject) => {
        formData.value.content = /^PHA\+PGJyPjwvcD4=/.test(formData.value.content) ? null : formData.value.content;
        formRef.value.validate((valid) => {
            if (valid) {
                if(formData.value.type == 0){
                  if (formData.value.department.length == 0) {
                      ElMessage.warning(`请选择接收` + formData.value.departmentType);
                      reject('未选接收部门');
                      return;
                  }
                }
                if (totalRoleUsers.value.length == 0) {
                    ElMessage.warning('请选择指定接收人');
                    reject('未选接收人');
                    return;
                }
                console.log(formData.value)
                const data = {
                    ...formData.value,
                    role: formData.value.role.join(','),
                    ccRole: formData.value.ccRole.join(','),
                    ccUser: totalCCRoleUsers.value.map(item => item.userId).join(','),
                    roleUser: totalRoleUsers.value.map(item => item.userId).join(','),
                    status: status,
                }
                resolve(data);
            } else {
                reject('表单校验失败');
            }
        });
    });
}
const resetForm = () => {
    roleUsers.value = [];
    eRoleUserStrList.value = [];
    eRoleUserList.value = [];
    totalRoleUsers.value = [];
    ccUsers.value = [];
    eCCUserStrList.value = [];
    eCCUserList.value = [];
    totalCCRoleUsers.value = [];
    formData.value = { filesUrlShow: 0,ccRole:[] ,role:[]};
    formRef.value && formRef.value.resetFields();
    receiverList.value = receiverList.value.map(item => ({ ...item, value: null }));
    ccReceiverList.value = ccReceiverList.value.map(item => ({ ...item, value: null }));
};
const typeChange = (v)=>{
      formData.value.role = []
      formData.value.ccRole = []
      totalCCRoleUsers.value = [];
      totalRoleUsers.value = [];
      eRoleUserStrList.value = [];
      eCCUserStrList.value = [];
      formData.value.departmentType = ''
      formData.value.department = ''
}
defineExpose({
    commit,
    resetForm,
    loadData
})
</script>

<style lang="scss" scoped>
.flex-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

// scoped样式下这样写
.form-star ::v-deep(.el-form-item__label)::before {
    color: var(--el-color-danger);
    content: "*";
    margin-right: 4px;
}

.selector-warp {
    padding-left: 10px;
}

.flex-row {
    display: flex;
    width: 100%;
    flex-direction: row;

    .text {
        padding-left: 15px;
        word-break: break-all; // 英文长串自动换行
        white-space: normal;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        flex: 1;
    }

}
</style>
